module.exports = __webpack_public_path__ + "img/ehealthcare_solutions_plugin.444df1a7.png";